import type { Character, WorldElement } from '../api/types';

export function audioRecord(value: unknown): Record<string, unknown> {
  if (typeof value === 'string') {
    try { return audioRecord(JSON.parse(value)); } catch { return {}; }
  }
  return value && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : {};
}

// Nur bereits vorhandene Nummern erhalten. Die deterministische Bestandswahl
// gehört dem Server; offline wird weder eine Anbieter-ID noch eine Ersatznummer geraten.
function publicCachedVoice(value: unknown): Record<string, unknown> {
  const voice = audioRecord(value);
  const no = typeof voice.no === 'number' && Number.isInteger(voice.no) && voice.no >= 1 && voice.no <= 6 ? voice.no : null;
  const traits = Array.isArray(voice.traits) ? voice.traits.filter((key): key is string => typeof key === 'string' && /^voice\.traits\.[a-z0-9_]{1,80}$/.test(key)).slice(0, 3) : [];
  return { ...(no === null ? {} : { no }), ...(traits.length ? { traits } : {}) };
}

export function sanitizeCachedCharacter(row: Character): Character {
  const result = { ...row } as Character & { call_voice?: unknown };
  const data = audioRecord(row.companion_data);
  result.companion_data = { ...data, voice: publicCachedVoice(data.voice) };
  delete result.call_voice;
  return result;
}

export function sanitizeCachedNpc(row: WorldElement): WorldElement {
  if (row.type !== 'npc') return row;
  const result = { ...row } as WorldElement & { call_voice?: unknown };
  const data = audioRecord(row.type_data);
  const npc = { ...audioRecord(data.npc), voice: publicCachedVoice(audioRecord(data.npc).voice) };
  delete (npc as Record<string, unknown>).call_voice;
  result.type_data = { ...data, npc };
  delete result.call_voice;
  return result;
}

export function characterVoice(row: Character): unknown { return audioRecord(row.companion_data).voice; }
export function npcVoice(row: WorldElement): unknown { return audioRecord(audioRecord(row.type_data).npc).voice; }
